/**
 * Lightweight Canadian postal code helpers for manual-entry UX.
 * Spreadsheet upload validation is enforced by the backend (canadian-form.util.ts).
 */

/**
 * Canada Post format: letter-digit-letter digit-letter-digit.
 * First letter excludes D,F,I,O,Q,U,W,Z. Later letters exclude D,F,I,O,Q,U only (W/Z allowed).
 */
const CANADIAN_POSTAL_CODE_REGEX =
  /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTVWXYZ]\d[ABCEGHJ-NPRSTVWXYZ]\d$/i;

/**
 * Normalizes a postal code by stripping spaces and hyphens and converting to uppercase.
 */
export const normalizePostalCode = (postalCode: string): string => {
  return postalCode.replace(/[\s-]/g, '').toUpperCase();
};

/**
 * Validates a Canadian postal code (A1A 1A1 pattern; excludes D, F, I, O, Q, U).
 */
export const isValidCanadianPostalCode = (postalCode: string): boolean => {
  if (!postalCode) return false;

  const cleaned = normalizePostalCode(postalCode);
  if (cleaned.length !== 6) return false;

  return CANADIAN_POSTAL_CODE_REGEX.test(cleaned);
};
